import { useEffect, useState } from "react";

import SelectNative from "~/components/select/SelectNative";
import SettingRow from "~/components/settings/SettingRow";

interface SettingSelectOption {
	label: string;
	value: string | number;
}

interface SettingSelectRowProps {
	description?: string;
	label: string;
	minWidth?: number;
	noBlank?: boolean;
	onSave: (value: string) => Promise<boolean>;
	options: SettingSelectOption[];
	readOnlyNote?: string;
	value: string;
}

const SettingSelectRow = ({
	description,
	label,
	minWidth = 320,
	noBlank,
	onSave,
	options,
	readOnlyNote,
	value
}: SettingSelectRowProps) => {
	const [pending, setPending] = useState<string | null>(null);
	const displayValue = pending ?? value;

	useEffect(() => {
		if (pending !== null && pending === value) setPending(null);
	}, [pending, value]);

	const handleChange = async (next: string) => {
		setPending(next);
		const success = await onSave(next);
		if (!success) setPending(null);
	};

	return (
		<SettingRow
			control={
				<SelectNative
					disabled={readOnlyNote !== undefined}
					helperText={readOnlyNote}
					label=""
					noBlank={noBlank}
					onChange={(e) => handleChange(e.target.value)}
					options={options}
					size="small"
					slotProps={{ select: { SelectDisplayProps: { "aria-label": label } } }}
					sx={{ minWidth }}
					value={displayValue}
					variant="standard"
				/>
			}
			description={description}
			label={label}
		/>
	);
};

export default SettingSelectRow;
